import React from "react";
import { Link } from "../../../../packages/router/Link.js";

type Props = {
  entryId: string;
};

/**
 * Renders the entry edit link.
 */
export const EditLink = ({ entryId }: Props) => {
  return (
    <Link to={`/edit/${entryId}`} className="button print-none">
      Muuda
    </Link>
  );
};
